var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mt-4 mb-4"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.key,staticClass:"w-1/2 pt-4 pb-2 align-middle text-center text-sm cursor-pointer border-b-2 border-gray-300 text-gray-300",class:[
      _vm.activeTab === tab.key
        ? 'font-semibold text-green-600 border-green-600'
        : tab.disabled
        ? 'hover:cursor-default'
        : ''
    ],on:{"click":function($event){!tab.disabled && _vm.$emit('toggle', tab.key)}}},[_vm._v(" "+_vm._s(tab.value)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }